import { TitleSegment } from '@britishcouncil/react-admin';
import styled from '@emotion/styled';
import { SegmentGroup, TabPane, Divider } from 'semantic-ui-react';
import { useSpeakingSlots } from './useSpeakingSlots';
import { AddRoomButton } from './AddRoomButton';
import { NoRoomsSelectedPlaceholder } from './NoRoomsSelectedPlaceholder';
import { DebouncedLoader, ErrorsContextProvider, ValidationErrors } from 'components';
import { SpeakingSlotsFooter } from './SpeakingSlotsFooter';
import { Rooms } from './structures';
import { useSpeakingSessionAllowedActions } from 'hooks';

export const SpeakingSlots = () => {
  const { speakingSessionRooms, roomsEvents, isLoading, anyRoomsAvailable } = useSpeakingSlots();
  const { canAssignRooms } = useSpeakingSessionAllowedActions();

  const showAddRoomsButton = anyRoomsAvailable && canAssignRooms;

  if (isLoading) return <DebouncedLoader />;

  return (
    <TabPane>
      <S.Actions>
        {showAddRoomsButton ? <AddRoomButton /> : undefined}
      </S.Actions>
      <Divider />
      <ErrorsContextProvider>
        <S.ValidationErrors />
        {anyRoomsAvailable ? (
          <Rooms speakingSessionRooms={speakingSessionRooms} roomsEvents={roomsEvents} />
        ) : (
          <NoRoomsSelectedPlaceholder />
        )}
      </ErrorsContextProvider>
      <SpeakingSlotsFooter />
    </TabPane>
  );
};

const S = {
  SegmentGroup: styled(SegmentGroup)`
    &.ui.segments {
      margin-bottom: unset;
      & > .ui.segment {
        border-radius: 0;
      }
    }
  `,
  TitleSegment: styled(TitleSegment)`
    &.ui.segment {
      z-index: 9999;
      position: sticky;
    }
  `,
  ValidationErrors: styled(ValidationErrors)`
    & > .content > div {
      scroll-margin-top: 80px;
    }
  `,
  Actions: styled.div`
    display: flex;
    justify-content: end;
  `,
};